import React from 'react';
import { BaseComponent } from './BaseComponent.js';
import { BaseTemplate } from './BaseTemplate.js';
import { Endpoint } from './Endpoint.js';
import { ThermostatEndpoint } from './endpoints/ThermostatEndpoint.js';
import { IASZoneEndpoint } from './endpoints/IASZoneEndpoint.js';
import { SmartPlugEndpoint } from './endpoints/SmartPlugEndpoint.js';
import { OnOffEndpoint } from './endpoints/OnOffEndpoint.js';
import { TemperatureSensorEndpoint } from './endpoints/TemperatureSensorEndpoint.js';
import { BatteryGraph } from './BatteryGraph.js';
import $ from 'jquery';
import FontAwesome from 'react-fontawesome';
import AutosizeInput from 'react-input-autosize';
import { NavLink  } from 'react-router-dom';

export class SingleSubDevice extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      urlTunnel: 'https://sparkjvm.com/cloud/json',
      apiTunnel: 'CreateTunnel',
      ieee: props.match.params.ieee,
      deviceID: parseInt(props.match.params.id, 10),
      subDevice: '',
      device: '',
      tunnel: {
        URL: '',
      },
      iconName: 'edit',
      editName: 'false',
      online: 0,
      lastTimestamp: '',
    };

    this.renderEndpoint = this.renderEndpoint.bind(this);
    this.renderAllEndpoint = this.renderAllEndpoint.bind(this);
    // this.renderInputRegister = this.renderInputRegister.bind(this);
    // this.renderAllInputRegisters = this.renderAllInputRegisters.bind(this);
    this.renderChildren = this.renderChildren.bind(this);
    this.setTitle = this.setTitle.bind(this);
    this.toggleEditTitle = this.toggleEditTitle.bind(this);
    this.isValidIeee = this.isValidIeee.bind(this);
    this.renderDataZigbee = this.renderDataZigbee.bind(this);
    this.renderDataModbus = this.renderDataModbus.bind(this);
    this.getModbusData = this.getModbusData.bind(this);
    this.updateTunnel = this.updateTunnel.bind(this);
  }

  isValidIeee() {
    if (this.state.ieee.indexOf(':') !== -1) {
      return true;
    }
    return false;
  }

  componentDidMount() {
    this.getParentDevice();
    this.createTunnel();
  }

  getParentDevice() {
    $.ajax({
      method: 'POST',
      url: 'https://sparkjvm.com/cloud/json',
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Action: 'GetDevices'
      }),
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res) => {
        if (res.Devices) {
          let i = 0;
          while (i < res.Devices.length) {
            if (res.Devices[i].id === this.state.deviceID) {
              this.setState({ device: res.Devices[i] });
            }
            i++;
          }
        }
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  getSubDeviceNoTunnel() {
    $.ajax({
      method: 'POST',
      url: 'https://sparkjvm.com/cloud/json',
      headers: {
        'x-session': this.props.token,
      },
      dataType: 'json',
      data: JSON.stringify({
        Action: 'GetStoredData',
        DeviceID: this.state.deviceID,
        Queue: 100,
        Limit: 1,
      }),
      xhrFields: {
        withCredentials: true
      },
      success: (res) => {
        if (res && res.Data.length) {
          let i = 0;
          while (i < res.Data[0].length) {
            if (res.Data[0][i].Id === parseInt(this.state.ieee, 10)) {
              this.setState({ subDevice: res.Data[0][i], online: 0, lastTimestamp: res.Timestamp[0] });
            }
            i++;
          }
        }
      },
      error: (httpReq, status, exception) => {
        console.log(httpReq);
        console.log(status);
        console.log(exception);
      },
    });
  }

  getSubDevice() {
    if (this.state.tunnel.URL) {
      $.ajax({
        method: 'GET',
        url: this.state.tunnel.URL + '/zigbee/json',
        headers: {
          'x-session': this.props.token,
        },
        xhrFields: {
          withCredentials: true
        },
        dataType: 'JSON',
        success: (res) => {
          if (res) {
            let i = 0;
            while (i < res.Nodes.length) {
              if (res.Nodes[i].IEEEAddress === this.state.ieee) {
                this.setState({ subDevice: res.Nodes[i], online: 1 });
              }
              i++;
            }
          }
        },
        error: (httpReq, status, exception) => {
          this.checkLoginStatus();
        },
      });
    }
  }

  getSubDeviceModbus() {
    if (this.state.tunnel.URL) {
      $.ajax({
        method: 'GET',
        url: this.state.tunnel.URL + '/energy/storage/json',
        headers: {
          'x-session': this.props.token,
        },
        xhrFields: {
          withCredentials: true
        },
        dataType: 'JSON',
        success: (res) => {
          if (res) {
            let i = 0;
            while (i < res.length) {
              if (res[i].Id === parseInt(this.state.ieee, 10)) {
                this.setState({ subDevice: res[i], online: 1 });
              }
              i++;
            }
          }
        },
        error: (httpReq, status, exception) => {
          this.checkLoginStatus();
        },
      });
    }
  }

  updateTunnel() {
    $.ajax({
      method: 'POST',
      url: this.state.urlTunnel,
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Action: this.state.apiTunnel,
        DeviceID: this.state.deviceID,
      }),
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res) => {
        // console.log('UPDATE TUNNEL');
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  createTunnel() {
    if (!this.isValidIeee) {
      this.getSubDeviceNoTunnel()
    }
    $.ajax({
      method: 'POST',
      url: this.state.urlTunnel,
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Action: this.state.apiTunnel,
        DeviceID: this.state.deviceID,
      }),
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res) => {
        if (res.Tunnel) {
          this.setState({ tunnel: res.Tunnel });

          if (this.isValidIeee()) {
            this.getSubDevice()
          } else {
            this.getSubDeviceModbus()
          }

          setInterval(() => {
            if (this.isValidIeee) {
              // this.getSubDevice()
            } else {
              this.getSubDeviceModbus()
            }
          }, 8000);

          setInterval(() => {
            this.updateTunnel();
          }, res.Tunnel.MinDuration*1000);
        }
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  requestApps() {
    $.ajax({
      method: 'GET',
      url: this.state.tunnel.URL + '/apps/json',
      headers: {
        'x-session': this.props.token,
      },
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res) => {
        if (res.Apps) {
          this.setState({ apps: res.Apps });
        } else {
          this.setState({ apps: false });
        }
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  renderLoader() {
    if (!this.state.overlayLoaded) {
      return(
        <div className="loader">
          <div className="loader__content">
            <FontAwesome
              className='loader__content__icon'
              name='spinner'
              spin
            />
          </div>
        </div>
      );
    }
  }

  renderStatus() {
    if (this.state.subDevice) {
      if (this.state.subDevice.Active === true) {
        return (
          <span className="circle circle--enable">
            <span>Attivato</span>
          </span>
        );
      } else if (this.state.subDevice.Active === false) {
        return (
          <span className="circle circle--disable">
            <span>Disattivato</span>
          </span>
        );
      }
    }
    return '';
  }

  setTitle(e) {
    let subDevice = this.state.subDevice;
    subDevice.Description = e.target.value;
    this.setState({ subDevice: subDevice });
  }

  toggleEditTitle() {
    if (this.state.iconName === 'edit') {
      // Entra in modifica
      this.setState({ iconName: 'check', editName: '' });
    } else {
      // Esci dalla modifica
      this.setState({ iconName: 'edit', editName: 'false' });

      // Salva
      $.ajax({
        method: 'POST',
        url: this.state.tunnel.URL + '/zigbee/json',
        headers: {
          'x-session': this.props.token,
        },
        xhrFields: {
          withCredentials: true
        },
        data: JSON.stringify({
          Address: this.state.ieee,
          Command: "Set Description",
          Parameters: [this.state.subDevice.Description],
        }),
        dataType: 'JSON',
        success: (res) => {},
        error: (httpReq, status, exception) => {
          this.checkLoginStatus();
        },
      });
    }
  }

  renderName() {
    if (this.state.subDevice && this.state.subDevice.Description) {
      return (
        <div>
          <ul className="breadcrumbs">
            <li><NavLink key="devices" to={`${process.env.PUBLIC_URL}/`}>Dispositivi</NavLink></li>
            <li><NavLink key={ this.state.deviceID } to={`${process.env.PUBLIC_URL}/devices/device-` + this.state.deviceID + `-a`}>{ this.state.device.Description }</NavLink></li>
          </ul>
          <AutosizeInput
            placeholder="Inserisci un nome per il sensore"
            style={{ fontSize: 30 }}
            className="title-relative"
          	value={ this.state.subDevice.Description }
          	onChange={ this.setTitle }
            disabled={ this.state.editName }
          />
          <FontAwesome
            className="title-relative-icon"
            name={ this.state.iconName }
            onClick={ this.toggleEditTitle }
          />
        </div>
      )
    }
    return (
      <div>
        <ul className="breadcrumbs">
          <li><a href="/">Dispositivi</a></li>
          <li><a href={ '/device-' + this.state.deviceID }>{ this.state.device.Description }</a></li>
        </ul>
        <AutosizeInput
          placeholder="Inserisci un nome per il sensore"
          style={{ fontSize: 30 }}
          className="title-relative"
          value=""
          onChange={ this.setTitle }
          disabled={ this.state.editName }
        />
        <FontAwesome
          className="title-relative-icon"
          name={ this.state.iconName }
          onClick={ this.toggleEditTitle }
        />
      </div>
    )
  }


  renderData() {
    if (this.isValidIeee()) {
      return this.renderDataZigbee();
    } else {
      //MODBUS
      return this.renderDataModbus();
    }
  }

  renderDataZigbee() {
    if (this.state.subDevice) {
      const active = this.state.subDevice.Active ? (
        <div className="single-device__content__data__row">
          <div className="single-device__content__data__row__label">Active</div>
          <div className="single-device__content__data__row__content">true</div>
        </div>
      ) : (
        <div className="single-device__content__data__row">
          <div className="single-device__content__data__row__label">Active</div>
          <div className="single-device__content__data__row__content">false</div>
        </div>
      );

      const lastActivity = this.state.subDevice.LastActivity ? (
        <div className="single-device__content__data__row">
          <div className="single-device__content__data__row__label">Last Activity</div>
          <div className="single-device__content__data__row__content">{ this.state.subDevice.LastActivity }</div>
        </div>
      ) : (
        ''
      );

      const logicalType = this.state.subDevice.LogicalType ? (
        <div className="single-device__content__data__row">
          <div className="single-device__content__data__row__label">Logical Type</div>
          <div className="single-device__content__data__row__content">{ this.state.subDevice.LogicalType }</div>
        </div>
      ) : (
        ''
      );

      const ieeeAddress = this.state.subDevice.IEEEAddress ? (
        <div className="single-device__content__data__row">
          <div className="single-device__content__data__row__label">IEEEAddress</div>
          <div className="single-device__content__data__row__content">{ this.state.subDevice.IEEEAddress }</div>
        </div>
      ) : (
        ''
      );

      const panid = this.state.subDevice.PANID ? (
        <div className="single-device__content__data__row">
          <div className="single-device__content__data__row__label">PANID</div>
          <div className="single-device__content__data__row__content">{ this.state.subDevice.PANID }</div>
        </div>
      ) : (
        ''
      );

      const channel = this.state.subDevice.Channel ? (
        <div className="single-device__content__data__row">
          <div className="single-device__content__data__row__label">Channel</div>
          <div className="single-device__content__data__row__content">{ this.state.subDevice.Channel }</div>
        </div>
      ) : (
        ''
      );

      const networkAddress = this.state.subDevice.NetworkAddress ? (
        <div className="single-device__content__data__row">
          <div className="single-device__content__data__row__label">Network Address</div>
          <div className="single-device__content__data__row__content">{ this.state.subDevice.NetworkAddress }</div>
        </div>
      ) : (
        ''
      );

      return(
        <div className="single-device__content__data">
          { active }
          { ieeeAddress }
          { panid }
          { channel }
          { lastActivity }
          { logicalType }
          { networkAddress }
        </div>
      )
    }
    return(
      <div className="single-device__content__data">
        <div className="single-device__content__data__none">
          Caricamento dati...
        </div>
      </div>
    )
  }

  renderDataModbus() {
    if (this.state.subDevice) {
      const status = this.state.subDevice.Status ? (
        <div className="single-device__content__data__row">
          <div className="single-device__content__data__row__label">Status</div>
          <div className="single-device__content__data__row__content">{ this.state.subDevice.Status }</div>
        </div>
      ) : (
        ''
      );

      const address = this.state.subDevice.Address ? (
        <div className="single-device__content__data__row">
          <div className="single-device__content__data__row__label">Address</div>
          <div className="single-device__content__data__row__content">{ this.state.subDevice.Address }</div>
        </div>
      ) : (
        ''
      );

      const id = this.state.subDevice.Id ? (
        <div className="single-device__content__data__row">
          <div className="single-device__content__data__row__label">ID</div>
          <div className="single-device__content__data__row__content">{ this.state.subDevice.Id }</div>
        </div>
      ) : (
        ''
      );

      let on = 0;
      if (this.state.online) {
        on = 1;
        if (this.state.subDevice.Status.toLowerCase() == 'down' || this.state.subDevice.Status.toLowerCase() == 'notpresent') {
          on = 0;
        }
      }

      let lastSeen = on ? (
        ''
      ) : (
        <div className="single-device__content__data__row">
          <div className="single-device__content__data__row__label">Last seen</div>
          <div className="single-device__content__data__row__content">{ this.timestampToDate(this.state.lastTimestamp) }</div>
        </div>
      );
      if (this.state.online) {
        lastSeen = '';
      }


      return(
        <div className="single-device__content__data">
          { id }
          { address }
          { status }
          { lastSeen }
        </div>
      )
    }
    return(
      <div className="single-device__content__data">
        <div className="single-device__content__data__none">
          Caricamento dati...
        </div>
      </div>
    )
  }
/*
  renderInputRegister(index) {
    if (this.state.subDevice.InputRegisters[index]) {
      let inputRegister = this.state.subDevice.InputRegisters[index];
      console.log(this.state.subDevice.InputRegisters[index]);
      return(
        <div className="single-device">
          <div className="single-device__topbar">{ inputRegister.Name }</div>
          <div className="single-device__content">
            <div className="single-device__content__data">
              <div className="single-device__content__data__row">
                <div className="single-device__content__data__row__label">Address</div>
                <div className="single-device__content__data__row__content">{ inputRegister.Address }</div>
              </div>
              <div className="single-device__content__data__row">
                <div className="single-device__content__data__row__label">Value</div>
                <div className="single-device__content__data__row__content">{ inputRegister.Value } { inputRegister.Unit }</div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
*/
  renderEndpoint(index) {
    if (this.state.subDevice.Endpoints[index].DeviceType === 'Thermostat') {
      return(
        <ThermostatEndpoint tunnelURL={ this.state.tunnel.URL } endpoint={ this.state.subDevice.Endpoints[index] } endpointIndex={ index } token={ this.props.token } deviceID={ this.state.deviceID } ieee={ this.state.ieee } />
      );
    } else if (this.state.subDevice.Endpoints[index].DeviceType === 'IAS Zone') {
      return(
        <IASZoneEndpoint tunnelURL={ this.state.tunnel.URL } endpoint={ this.state.subDevice.Endpoints[index] } endpointIndex={ index } token={ this.props.token } deviceID={ this.state.deviceID } ieee={ this.state.ieee } />
      );
    } else if (this.state.subDevice.Endpoints[index].DeviceType === 'Smart Plug') {
      return(
        <SmartPlugEndpoint tunnelURL={ this.state.tunnel.URL } endpoint={ this.state.subDevice.Endpoints[index] } endpointIndex={ index } token={ this.props.token } deviceID={ this.state.deviceID } ieee={ this.state.ieee } />
      )
    } else if (this.state.subDevice.Endpoints[index].DeviceType === 'On/Off Switch') {
      return(
        <OnOffEndpoint tunnelURL={ this.state.tunnel.URL } endpoint={ this.state.subDevice.Endpoints[index] } endpointIndex={ index } token={ this.props.token } deviceID={ this.state.deviceID } ieee={ this.state.ieee } />
      )
    } else if (this.state.subDevice.Endpoints[index].DeviceType === 'Temperature Sensor') {
      return(
        <TemperatureSensorEndpoint tunnelURL={ this.state.tunnel.URL } endpoint={ this.state.subDevice.Endpoints[index] } endpointIndex={ index } token={ this.props.token } deviceID={ this.state.deviceID } ieee={ this.state.ieee } />
      )
    }

    return(
      <Endpoint tunnelURL={ this.state.tunnel.URL } endpoint={ this.state.subDevice.Endpoints[index] } endpointIndex={ index } token={ this.props.token } deviceID={ this.state.deviceID } ieee={ this.state.ieee } />
    );
  }

  renderChildren() {
    if (this.isValidIeee()) {
      return this.renderAllEndpoint();
    } else {
      // return this.renderAllInputRegisters();
      return this.renderAllModbus();
    }
  }

  renderBattery() {
    if (!this.isValidIeee()) {
      let online = this.state.online;
      if (this.state.subDevice && this.state.subDevice.Status) {
        if (this.state.subDevice.Status.toLowerCase() == 'down' || this.state.subDevice.Status.toLowerCase() == 'notpresent') {
          online = 0;
        }
      }
      return(
        <BatteryGraph
          batteries={ this.state.subDevice }
          tunnelURL={ this.state.tunnel.URL }
          token={ this.props.token }
          deviceID={ this.state.deviceID }
          ieee={ this.state.ieee }
          online={ online }
        />
      )
    }
    return '';
  }

  getModbusData(json, name) {
    if (json.hasOwnProperty(name)) {
      return(
        <div className="single-device__content__data__row">
          <div className="single-device__content__data__row__label">{ name }</div>
          <div className="single-device__content__data__row__content">{ json[name] }</div>
        </div>
      );
    }
    return '';
  }

  renderAllModbus() {
    if (this.state.subDevice) {
      let json = this.state.subDevice;
      return(
        <div className="single-device">
          <div className="single-device__topbar">{ json.Description }</div>
          <div className="single-device__content">
            <div className="single-device__content__data">
              { this.getModbusData(json, 'ALARM_STOR') }
              { this.getModbusData(json, 'F_GRID') }
              { this.getModbusData(json, 'P_DC_STOR') }
              { this.getModbusData(json, 'P_GRID') }
              { this.getModbusData(json, 'P_PV') }
              { this.getModbusData(json, 'P_PV1') }
              { this.getModbusData(json, 'P_STOR') }
              { this.getModbusData(json, 'Q_GRID') }
              { this.getModbusData(json, 'Q_STOR') }
              { this.getModbusData(json, 'SOC_STOR') }
              { this.getModbusData(json, 'SOH_STOR') }
              { this.getModbusData(json, 'STATE_STOR') }
              { this.getModbusData(json, 'T_MAX_CELL') }
              { this.getModbusData(json, 'T_MIN_CELL') }
              { this.getModbusData(json, 'T_STOR') }
              { this.getModbusData(json, 'V_DC_STOR') }
              { this.getModbusData(json, 'V_GRID') }
              { this.getModbusData(json, 'C_STOR') }
              { this.getModbusData(json, 'I_DC_STOR') }
              { this.getModbusData(json, 'I_PV1') }
              { this.getModbusData(json, 'I_PV2') }
              { this.getModbusData(json, 'I_USER') }
              { this.getModbusData(json, 'P_USER') }
              { this.getModbusData(json, 'V_PV1') }
              { this.getModbusData(json, 'V_PV2') }
              { this.getModbusData(json, 'V_USER') }
              { this.getModbusData(json, 'E_TOT_IMP') }
              { this.getModbusData(json, 'I_GRID') }
              { this.getModbusData(json, 'OP_TIME') }
              { this.getModbusData(json, 'P_EPS') }
            </div>
          </div>
        </div>
      );
    }
    return '';
  }

/*
  renderAllInputRegisters() {
    if (this.state.subDevice) {
      let i = 0;
      const inputRegister = this.state.subDevice.InputRegisters.map((ir) => {
        const a = this.renderInputRegister(i);
        i++;
        return(
          <div key={i}>{ a }</div>
        );
      });
      return inputRegister;
    }
    return '';
  }
*/

  renderAllEndpoint() {
    if (this.state.subDevice) {
      let i = 0;
      const endpoints = this.state.subDevice.Endpoints.map((ep) => {
        const a = this.renderEndpoint(i);
        i++;
        return(
          <div key={i}>{ a }</div>
        );
      });
      return endpoints;
    }
    return '';
  }

  render() {
    return (
      /*
      // METTERE DOPO { this.renderBattery() }
      { this.renderChildren() }
      */
      <BaseTemplate>
        { this.renderName() }
        { this.renderBattery() }
        <div className="single-device">
          <div className="single-device__topbar">Dati generici { this.renderStatus() }</div>
          <div className="single-device__content">{ this.renderData() }</div>
        </div>
        { this.renderChildren() }
      </BaseTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SingleSubDevice.js